module.exports = __webpack_public_path__ + "static/media/spf_logo.7eefca98.png";